import { ModalContext } from "../../components/BrowserAlert/modalContext";
import React from "react";
import { useParams } from "react-router-dom";
import { Button, Stack } from "@common-ui/ui";
import {
  //  useDispatch,
  useSelector,
} from "react-redux";
import { serviceSlice } from "../../reducers/serviceReducer";

import { postServiceOption, patchServiceOption } from "../../services/services";

export const Footer = ({ history, dispatch, setRefresh }) => {
  let { handleModal } = React.useContext(ModalContext);
  const params = useParams();
  const newServiceOptions = useSelector(
    (state) => state.service.newServiceOptions
  );

  const serviceOptions = useSelector((state) => state.service.serviceOptions);

  const handleAddServiceOptions = async () => {
    try {
      if (serviceOptions?.length) {
        await patchServiceOption(params?.id, params?.orgId, serviceOptions);
      }
      const response = await postServiceOption(
        params?.id,
        params?.orgId,
        newServiceOptions
      );
      if (response === 200) {
        history.go(0);
      }
    }  catch (error) {
      alert(
        error?.response?.status === 405
        ? handleModal("Service Options in a service should be unique!!", "Alert")
          // ? "Service Options in a service should be unique!!"
          : error
      );
      history.go(0);
    }
  };

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      justifyContent="flex-end"
      spacing={{ xs: 1, md: 2 }}
      sx={{ py: 2 }}
    >
      <div>
        <Button
          color="primary"
          // disabled={formik.isSubmitting}
          fullWidth
          size="large"
          onClick={() => {
            dispatch(serviceSlice.actions.clearServiceOptions());
          }}
          variant="text"
        >
          Cancel
        </Button>
      </div>
      <div>
        <Button
          color="primary"
          disabled={
            !newServiceOptions.length && !serviceOptions.length
              ? true
              : [...newServiceOptions, ...serviceOptions].some(
                  (n) => n.name === "" || n.description === ""
                )
              ? true
              : false
          }
          fullWidth
          size="large"
          onClick={() => handleAddServiceOptions()}
          //   type="submit"
          variant="contained"
        >
          Save
        </Button>
      </div>
    </Stack>
  );
};
